  /* Jay - D210: Company Images Replaced */
  try {
    var allBannerIconArea = document.querySelectorAll(
      '.overview-content .tapo-d210_v1 .smart-motion-sensor .img-icon-wrap'
    );
    var bannerGoogleHome =
      '<img id="banner-d210-google-home" alt="work with google home icon" class="icon img-icon" src="https://static-product.tp-link.com/tapo-c225_v1/us/img/google-home.png">';
    var bannerAmazonAlexa =
      '<img id="banner-d210-amazon-alexa" alt="work with amazon alexa icon" class="icon img-icon" src="https://static-product.tp-link.com/tapo-c225_v1/us/img/amazon-alexa.png">';
    var bannerTapoCare =
      '<img id="banner-d210-tapo-care" alt="work with tapo care icon" class="icon img-icon last-item" src="https://static-product.tp-link.com/tapo-c225_v1/us/img/tapo-care.png">';
    var allBannerIconArea = document.querySelectorAll(
      '.overview-content .tapo-d210_v1 .smart-motion-sensor .img-icon-wrap'
    );
    if (allBannerIconArea.length > 0) {
      allBannerIconArea[0].innerHTML = bannerGoogleHome + ' ' + bannerAmazonAlexa + ' ' + bannerTapoCare;
      document.getElementById('banner-d210-google-home').onload = function () {
        this.classList.add('border');
      };
      document.getElementById('banner-d210-amazon-alexa').onload = function () {
        this.classList.add('border');
      };
      document.getElementById('banner-d210-tapo-care').onload = function () {
        this.classList.add('border');
      };
    }
  } catch (e) {}